export default "__VITE_ASSET__Bx7$Qkow__"